import { getDayStartAndEndHours } from 'domains/shifts/components/components/weekly-staffing/utils/getDayStartAndEndHours'
import {
  type StartAndEndDeliveryHour,
  type StoreHoursOffsets,
} from 'domains/shifts/components/components/weekly-staffing/utils/types'
import { type DeliveryHours } from 'domains/shifts/components/types'

/*
 * Returns daily start and end time offsets from the earliest start time and latest end time in the week, respectively.
 */
export const getHoursOffsetsPerDay: (
  regularHours: DeliveryHours[],
  hoursLimits: StartAndEndDeliveryHour
) => StoreHoursOffsets[] = (regularHours, hoursLimits) => {
  const hoursOffsets: StoreHoursOffsets[] = []

  regularHours.forEach(day => {
    const { start, end } = getDayStartAndEndHours(day)

    hoursOffsets.push({
      openingHoursOffset: start - hoursLimits.start,
      closingHoursOffset: hoursLimits.end - end,
    })
  })

  return hoursOffsets
}
